import type { CartHelpers } from './types';

export function useCartHelpers(): CartHelpers {
  const getCartProductVariantAttributeValueByExternalId = (
    cartLine: CartLine,
    externalId: string
  ): any => cartLine.productVariant && externalId;
  //cartLine.productVariant?.variantAttributesValues?.find((attr) => attr.id === externalId)?.value;

  const getCartOfferCustomFieldValueByExternalId = (cartLine: CartLine, externalId: string): any =>
    cartLine.offer && externalId;
  //cartLine.offer?.customFieldValues?.find((field) => field.id === externalId)?.value;

  return {
    getCartProductVariantAttributeValueByExternalId,
    getCartOfferCustomFieldValueByExternalId,
  };
}
